<template>
    <div class="biz-edit-policy">
        <div class="page-header">
            <h1>
                {{$route.meta.title}}
                <word-tips-hover data="合約條款所設定好的項目，會出現在合約版本裡，可以在合約版本中勾選是否要顯示。" width="400px"></word-tips-hover>
            </h1>
            <div class="btn-group">
                <!-- <button class="default-button publish" @click="saveHouse">新增</button> -->
            </div>
        </div>
        <div class="biz-edit-policy-wrap">
            <new-policy :type="1" :resize="false"></new-policy>
        </div>
    </div>
</template>
<script>
import NewPolicy from '@/components/bussiness/widges/tools/NewPolicy.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

export default {
    data () {
        return {
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})

    },
    methods: {
    },
    components: {
        NewPolicy,
        wordTipsHover
    }
}
</script>
<style lang="scss">
    .biz-edit-policy{
        .page-header{
            margin-bottom: 24px;
        }
        .biz-edit-policy-wrap{
            backdrop-filter: blur(10px);
            border: solid 1px #f0f0f0;
            background-color: #ffffff;
            padding: 20px 20px 24px;
            border-radius: 6px;
            .new-policy{
                .new-policy-head{
                    .view-default{
                        position: relative;
                        right: unset;
                        justify-content: flex-end;
                        width: 100%;
                    }
                }
                .new-policy-body{
                    overflow-x: unset;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/editPolicy/editPolicyComp.vue